
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ArrowTopTurnRightIcon extends Vue {
  @Prop({ default: '24' }) readonly size?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
